
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brand]/login",
      function () {
        return require("private-next-pages/[brand]/login.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brand]/login"])
      });
    }
  